import { useMemo } from 'react';
import useInventoryPools from './useInventoryPools';

const useInventoryPool = (vaultId: string) => {
  const { data: pools, status, error } = useInventoryPools();

  const pool = useMemo(() => {
    return pools?.find((pool) => pool.vaultId === vaultId);
  }, [pools, vaultId]);

  return { status, error, data: pool };
};

export default useInventoryPool;
